import { Component, Input, ViewChild, viewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { IS1InputSelectItem, S1InputSelect } from '@app/s1';
import { StazioneService, IRicercaStazioniEntrataParams } from '@app/shared/services/stazione.service';

@Component({
  selector: 'ser-stazione-entrata-select',
  templateUrl: './stazione-entrata-select.component.html',
  styleUrl: './stazione-entrata-select.component.scss'
})
export class StazioneEntrataSelectComponent {

  @Input() control: UntypedFormControl;
  @Input() readonly: boolean;
  @Input() label: string = 'assistenze.fields.stazioneEntrata';

  @Input() set idStazioneUscita(newValue: string) {
    this._idStazioneUscita = newValue;
    this.loadItems();
  }

  @Input() set data(newValue: Date) {
    this._data = newValue;
    this.loadItems();
  }

  @ViewChild('s1InputSelect')s1InputSelect: S1InputSelect;

  _idStazioneUscita: string;
  _data: Date;

  stazioni: IS1InputSelectItem[];

  constructor(private stazioneService: StazioneService) { }

  ngOnInit(): void { 
    this.loadItems();
  }

  loadItems() {

    if (this._idStazioneUscita == null || this._data == null) {
      return;
    }

    const params: IRicercaStazioniEntrataParams = {
      page: 1,
      pageSize: 999,
      idStazioneUscita: this._idStazioneUscita,
      data: this._data
    }
  
    this.stazioneService.ricercaStazioniEntrata(params).subscribe(stazioniPaginate => {
  
      this.stazioni = stazioniPaginate?.elements?.map(stazione => { 
        return { code: stazione.id, label: stazione.descrizione?.trim() }  
      }) ?? [];

      if (this.stazioni?.length == 1) {
        this.control?.patchValue(this.stazioni[0].code);
      } else {
        
        const previousValue = this.control.value;

        if (previousValue) {
          const stillExist = this.stazioni.map(item => item.code).some(code => code == previousValue);
          if (!stillExist) {
            this.s1InputSelect.clear();
          }

        }

      }
  
    })

  }

}
